import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { Sparkles } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

/**
 * Floating "Generate my AI agent" button.
 * Sits above the chat bubble and jumps to /technology#configurator.
 *
 * Icon-only by default; the label reveals on hover (native tooltip is set
 * via aria-label, plus a custom pill tooltip for cursor users).
 */
export default function AgentFloatButton() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [hover, setHover] = useState(false);

    // On /technology the configurator is already visible on-page, so the
    // floating CTA is redundant (and covers the "Your agent" panel on desktop).
    if (pathname === "/technology") return null;

    const go = () => navigate("/technology#configurator");

    return (
        <div
            style={{ position: "fixed", right: 24, bottom: 138, zIndex: 149 }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {/* Hover pill tooltip */}
            <div
                style={{
                    position: "absolute",
                    right: "calc(100% + 10px)",
                    top: "50%",
                    transform: `translateY(-50%) scale(${hover ? 1 : 0.9})`,
                    opacity: hover ? 1 : 0,
                    pointerEvents: "none",
                    transition: "opacity .18s ease, transform .18s ease",
                    background: "rgba(10,13,18,0.95)",
                    color: "#e8ecf3",
                    padding: "8px 14px",
                    borderRadius: 10,
                    border: "1px solid rgba(143,208,255,0.35)",
                    fontSize: ".82rem",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
                    fontFamily: "inherit",
                }}
                aria-hidden
            >
                Generate my AI agent
            </div>

            <button
                data-testid={TESTIDS.agentFloat || "agent-float-btn"}
                onClick={go}
                aria-label="Generate my AI agent"
                title="Generate my AI agent"
                style={{
                    width: 54,
                    height: 54,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 999,
                    background: "linear-gradient(135deg, #8fd0ff, #6fb8f5)",
                    color: "#08090c",
                    border: "1px solid rgba(255,255,255,0.20)",
                    boxShadow:
                        "0 14px 30px rgba(143,208,255,0.35), 0 0 0 1px rgba(143,208,255,0.15) inset",
                    cursor: "pointer",
                    transition: "transform .18s ease, box-shadow .18s ease",
                    transform: hover ? "translateY(-2px)" : "none",
                }}
            >
                <Sparkles size={22} />
            </button>
        </div>
    );
}
